const NotFound = () => {
  return (
    <div className="d-flex vh-100 justify-content-center align-items-center bg-light text-center">
      <div>
        <h1 className="display-4 fw-bold">404 - Page Not Found</h1>
        <p className="lead">
          Sorry, the page you’re looking for doesn’t exist.
        </p>
      </div>
    </div>
  );
};

export default NotFound;
